import React, { useState, useEffect, useRef} from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Navbar.css';
import logo from '../Images/authlogo.png'

const Navbar = () => {

    const [isOpen, setIsOpen] = useState(false);
    
      const toggleMenu = () => {
        setIsOpen(!isOpen);
      }
    
      const closeMenu = () => {
        setIsOpen(false);
      }
      useEffect(() => {
        const handleResize = () => {
          if (window.innerWidth > 768) {
            setIsOpen(false); // Screen bari hone par navbar close ho jaye
          }
        };
    
        window.addEventListener('resize', handleResize);
        // Cleanup function taake memory leak na ho
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);


        // List open/close hone par background ko scroll aur pointer events disable/enable karein
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'; // Background scroll disable
      document.body.style.pointerEvents = 'none'; // Background click disable
    } else {
      document.body.style.overflow = 'auto'; // Background scroll enable
      document.body.style.pointerEvents = 'auto'; // Background click enable
    }

    // Cleanup function: Component unmount hone par background ko wapas enable karein
    return () => {
      document.body.style.overflow = 'auto';
      document.body.style.pointerEvents = 'auto';
    };
  }, [isOpen]);


  const navbarRef = useRef(null); // Reference for the menu list container
  // Close the navbar if clicked outside of it
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        navbarRef.current && 
        !navbarRef.current.contains(e.target) && 
        !e.target.closest(".navbar-menu-icon-container") // Ignore clicks on menu icon
      ) {
        closeMenu();
      }
    };

    if (isOpen) {
      document.addEventListener("click", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [isOpen]);


  return (
    <>
      {/* <div className={`navbar-overlay ${isOpen ? 'show' : ''}`} /> */}
      <nav ref={navbarRef} className={`navbar ${isOpen ? 'open' : ''}`} >
        <div className='navbar-header'>
          <i 
            className="ri-close-line" 
            onClick={closeMenu}
          />
        </div>
        <div className="navbar-links">
          {/* <Link to="/" className='logo-link' onClick={closeMenu} style={{fontFamily:'monospace'}}>InPkOnlineShop</Link> */}
          <Link to="/" className='logo-link'onClick={closeMenu}>
            <img src={logo} alt='error' className='logo-image'/>
          </Link>
          {/* <i class="ri-shopping-bag-line" /> */}
          <NavLink to="/" onClick={closeMenu}><i  class="ri-home-3-line" /> Home</NavLink>
          <NavLink to="/top_collections" onClick={closeMenu}><i class="ri-time-line" /> Watches</NavLink>
          <NavLink to="/our_collection" onClick={closeMenu}><i class="ri-headphone-line" /> Earbuds</NavLink>
          <NavLink to="/electronics" onClick={closeMenu}><i class="ri-wallet-3-line" /> Wallets</NavLink>
          <NavLink to="/home_improvement" onClick={closeMenu}><i class="ri-magic-line" /> Cosmetics</NavLink>
          <NavLink to="/about-us" onClick={closeMenu}><i class="ri-information-line" /> About us</NavLink>
          <NavLink to="/contact-us" onClick={closeMenu}><i class="ri-contacts-line" /> Contact us</NavLink>
        </div>
      </nav>
      <div className='navbar-menu-icon-container' >
        {/* {!isOpen ? ( */}
          <i className="ri-menu-2-line" onClick={toggleMenu} />
        {/* ) : (
          <>
          
          <div className='test'></div>
          </>
        )} */}
      </div>
      {/* <div className={`navbar-toggle ${isOpen ? 'navbar-toggle-open' : ''}`} onClick={toggleMenu}
           style={{ position: isListVisible ? 'fixed' : '' }}>
        <span className={`bar ${isOpen ? 'bar1' : ''}`}></span>
        <span className={`bar ${isOpen ? 'bar2' : ''}`}></span>
        <span className={`bar ${isOpen ? 'bar3' : ''}`}></span>
      </div> */}
    </>
  );
}

export default Navbar;
